// Datos de Outbound Loads: la lista de cargas de salida y, bajo demanda, el
// detalle de líneas de una carga.
//
// Sin paginar ni acotar por fecha desde aquí: la pantalla agrupa por
// proximidad (atrasadas / hoy / esta semana / …) y para eso necesita el
// conjunto entero que ya ha filtrado el backend (vivas, ≤30 días).
import { useQuery } from '@tanstack/react-query'
import { cargasSalidaApi } from '@/services/api'

export function useCargasSalida(params: { incluirExpedidas?: boolean; almacen?: string }) {
  const { data, isLoading, isError, isFetching, refetch } = useQuery({
    queryKey: ['cargas-salida', params.incluirExpedidas ?? false, params.almacen ?? ''],
    queryFn: () => cargasSalidaApi.list(params),
    staleTime: 60_000,
  })

  return {
    cargas: data?.data ?? [],
    updatedAt: data?.updatedAt,
    isLoading,
    isError,
    isFetching,
    refetch,
  }
}

/** Líneas de UNA carga, para el desplegable. `carga` a `null` no consulta nada:
 *  es lo que hay antes de abrir la fila y al cerrarla, y no tiene sentido pedir
 *  el detalle de una carga que no se está mirando. */
export function useCargaSalidaLineas(carga: string | null) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['cargas-salida', carga, 'lineas'],
    queryFn: () => cargasSalidaApi.getLineas(carga as string),
    enabled: !!carga,
    staleTime: 60_000,
  })

  return {
    lineas: data?.data ?? [],
    isLoading,
    isError,
  }
}

/** Diccionario de descripciones de artículo. Casi no cambia: caché larga. Si
 *  falla o tarda, el filtro sigue funcionando, sólo que sin descripciones. */
export function useArticulosCatalogo() {
  const { data } = useQuery({
    queryKey: ['cargas-salida', 'articulos'],
    queryFn: () => cargasSalidaApi.getArticulos(),
    staleTime: 30 * 60_000,
  })
  return data?.data
}
